import React from 'react';
import styled from 'styled-components';
import { variables } from '@splunk/themes';

type StyledInlineCodeProps = {
    wordBreak?: NonNullable<React.CSSProperties['wordBreak']>;
};

const StyledInlineCode = styled.span<StyledInlineCodeProps>`
    word-break: ${(props) => props.wordBreak};
    color: ${variables.contentColorActive};
    background-color: ${variables.interactiveColorOverlayActive};
    font-family: ${variables.monoFontFamily};
`;

export type InlineCodeProps = StyledInlineCodeProps & {
    text: string;
};

export const InlineCode = ({
    text,
    wordBreak = 'break-all',
}: InlineCodeProps): JSX.Element => (
    <StyledInlineCode wordBreak={wordBreak}>{text}</StyledInlineCode>
);
